import { render, staticRenderFns } from "./SortableList.vue?vue&type=template&id=209d55f8&scoped=true"
import script from "./SortableList.ts?vue&type=script&lang=ts&external"
export * from "./SortableList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209d55f8",
  null
  
)

export default component.exports